export default __webpack_public_path__ + "static/media/steel.08f9721f.svg";